import React from 'react'
import Sidebar from './Sidebar'
import Header from './Header'
import { Outlet } from 'react-router-dom';
import { useSideBarContext } from '../context/SidebarContext';

const Layout = () => {
    const { isSidebarHidden } = useSideBarContext();
    return (
        <>
            <Sidebar />
            <div className={`main-wrapper ${isSidebarHidden ? 'main-width' : ''}`}>

                <Header />
                {/* <Headings /> */}
                <Outlet />


                {/* <Outlet context={{ handleEyeClick }} /> */}
            </div>

        </>
    )
}

export default Layout